import axios from 'axios';
import { Indicator, Toast } from 'mint-ui';
import qs from 'qs'; // 字符串转换模块

axios.defaults.timeout = 60000;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

let isTest = GetParam(window.location.href, 'ac')
if (window.location.origin === 'https://gk.zhenzhang.com' || window.location.origin === 'http://gk.zhenzhang.com') {
  isTest = false;
}

// 请求拦截器
axios.interceptors.request.use(function(config) {
  if (config.method === 'post') {
    let data = new FormData();
    for (let it in config.data) { data.append(it, config.data[it]); }

    if (isTest) {
      data.append('access_token', isTest);
    } else {
      if (localStorage.getItem('cww_data')) { data.append('access_token', JSON.parse(localStorage.getItem('cww_data')).access_token); }
    }

    // if (localStorage.getItem('cww_data')) { data.append('access_token', JSON.parse(localStorage.getItem('cww_data')).access_token); }
    // data.append('access_token', "ZHvWALIoaOoRzEEaqaE3gbCVLiQhaveO");

    config.data = data;
  } else {

    if (isTest) {
      config.params.access_token = isTest;
    } else {
      if (localStorage.getItem('cww_data')) { config.params.access_token = JSON.parse(localStorage.getItem('cww_data')).access_token; }
    }

    // if (localStorage.getItem('cww_data')) { config.params.access_token = JSON.parse(localStorage.getItem('cww_data')).access_token; }
    // config.params.access_token = "ZHvWALIoaOoRzEEaqaE3gbCVLiQhaveO";
  }
  setTimeout(() => { Indicator.close(); }, axios.defaults.timeout)
  return config;
});
// 响应拦截器
axios.interceptors.response.use(function(config) {
  setTimeout(() => { Indicator.close(); }, 500);
  if (config.headers['content-type'] == "image/png") {
    config.data = {_imgUrl: config.request.responseURL, code: 0}
  }
  // config.data.code = Number(config.data.code);
  // 登录失败
  if (config.data.code === 101) {
    localStorage.clear();
    localStorage.removeItem('cww_data');
    Toast({message: config.data.msg, className: 'iconfont icon-close', duration: 1500});
    setTimeout(() => {
      window.location.reload();
    }, 1500);
  }

  return config;
});

export default {
  fetchGet(url, params = {}) {
    return new Promise((resolve, reject) => {
      axios.get(url, { params }).then(res => {
        resolve(res.data);
      }).catch(error => {
        Toast({message: '请求超时,请稍后重试', className: 'iconfont icon-close', duration: 2000});
        reject(error);
      });
    });
  },
  fetchPost(url, params = {}) {
    let config = {
      headers:{
        'Content-Type':'multipart/form-data'
      }
    };
    return new Promise((resolve, reject) => {
      axios.post(url, params, config).then(res => {
        resolve(res.data);
      }).catch(error => {
        Toast({message: '请求超时,请稍后重试', className: 'iconfont icon-close', duration: 2000});
        reject(error);
      });
    });
  }
};

function GetParam (url, id) {
  url = url+ "";
  let regstr = "/(\\?|\\&)" + id + "=([^\\&]+)/";
  let reg = eval(regstr);
  let result = url.match(reg);

  if (result && result[2]) {
    return result[2];
  }
}
